export enum FeatureFlagTypes {
  Salesforce = 'salesforce',
  VisibilityDashboard = 'visibility_dashboard',
  AllBuilders = 'all_builders',
  AccessType = 'access_type',
  ServiceNow = 'service_now',
  AiExtensions = 'ai_extensions',
  EnterpriseAiDashboard = 'enterprise_ai_dashboard',
  EnterpriseAiDetection = 'enterprise_ai_detection',
  MockPolicyDetectionRules = 'mock_policy_detection_rules',
  ChatGptEnterprise = 'chat_gpt_enterprise',
  AmazonBedrock = 'amazon_bedrock',
  IssuesPage = 'issues_page',
  AIRuntimePreventionMockTab = 'airuntime_prevention_mock_tab',
  AIRuntimeDataInsightsTab = 'airuntime_data_insights_tab',
  IntegrationsScansData = 'integrations_scans_data',
  PoliciesRulesExportCsvButton = 'policies_rules_export_csv_button',
  AIRuntimeInLineControlTab = 'airuntime_in_line_control_tab',
  PoliciesInLineControlRules = 'policies_in_line_control_rules',
  BrownfieldPlaybooks = 'brownfield_playbooks',
  Google = 'google',
}
